import * as dates from './dates';

export default function setDateInfoOfSplittedEvents(events) {
	const splittedEvents = {
	};
	events.forEach((event) => {
		const momentObj = dates.parseDatetimeString(event.begin);
		const timeStamp = momentObj.startOf('month').format('X');

		splittedEvents[timeStamp] = splittedEvents[timeStamp] ? splittedEvents[timeStamp] : [];
		splittedEvents[timeStamp] = [...splittedEvents[timeStamp], event];
	});
	return splittedEvents;
}

export function removeEmptyMonth(splittedEvents) {
	return Object.keys(splittedEvents)
		.filter(key => splittedEvents[key].length > 0)
		.reduce((obj, key) => {
			// eslint-disable-next-line
      obj[key] = splittedEvents[key];
			return obj;
		}, {});
}
